export const GIC_VIEW_TYPE = 'GIC' as const;
export const GIC_AGENT_VIEW_TYPE = 'GICAgentView' as const;
